module.exports = __webpack_public_path__ + "static/media/fire.192ea381.svg";